import { createContext } from 'react';

import { Config } from 'config/config';

const ConfigContext = createContext<Config>(null!);

export default ConfigContext;
